import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';
import { InspectCommentItem } from '../models/InspectCommentItem';

export class InspectCommentService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();

  public async getInspectComment() {
    const { result, error } = await this.commonService.get(
      `${this.baseAPI}/admin/inspectComment`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getInspectComment');
      return;
    }
  }

  public async editInspectComment(data: InspectCommentItem) {
    const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/inspectComment`, {
      ...data
    });
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'editInspectComment');
      return;
    }
  }

  public async getInspectImage(commentId: number) {
    const { result, error } = await this.commonService.get(
      `${this.baseAPI}/admin/inspectImage/${commentId}`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getInspectImage');
      return;
    }
  }

  public getUploadURL(commentId: number) {
    return `${this.baseAPI}/admin/inspectImage/${commentId}`;
  }

  public async uploadImage(file: any, commentId: number) {
    let data = new FormData();
    data.append('imageFile', file);
    const header = {
      'Content-Type': 'multipart/form-data'
    };
    const { result, error } = await this.commonService.post(`${this.baseAPI}/admin/inspectImage/${commentId}`,
      data, header);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'uploadImage');
      if (error && error.status) {
        return error.status;
      }
    }
  }

  public async deleteImage(imgId: number) {
    const { result, error } = await this.commonService.delete(`${this.baseAPI}/admin/inspectImage/${imgId}`);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'deleteImage');
      if (error && error.status) {
        return error.status;
      }
      return error;
    }
  }
}
